<template>
  <div class="home-container">
    <el-row :gutter="5">
      <el-col :xs="24"
              :sm="12"
              :md="6"
              :lg="6"
              :xl="6"
              class="pt-10 el-col-25"
              v-for="(item, index) in totalList"
              :key="index">
        <el-card shadow="none">
          <el-tooltip class="item"
                      effect="dark"
                      :content="item.type + '：' + item.nor + ' / ' + item.abn"
                      placement="top-start">
            <div class="home-top">
              <h4 class="home-top-title">
                <i class="el-icon-date mr-10"></i>{{ item.type }}
              </h4>
              <p>正常：
                <span :style="{ color: 'green' }">{{ item.nor }}</span>，{{ item.unit }}：
                <span :style="{ color: 'red' }">{{ item.abn }}</span>
              </p>
            </div>
          </el-tooltip>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import fetch from '@/common/api'
// import utils from '@/common/utils'
export default {
  data() {
    return {
      totalList: {
        sumPerson: {
          type: '人员统计',
          unit: '过期',
          nor: '0',
          abn: '0'
        },
        sumGate: {
          type: '网关统计',
          unit: '离线',
          nor: '0',
          abn: '0'
        },
        sumLock: {
          type: '门锁统计',
          unit: '离线',
          nor: '0',
          abn: '0'
        }
      }
    }
  },
  created() {
    this.apiOverview()
  },
  methods: {
    apiOverview() {
      fetch.getOverview().then((data) => {
        data.procData(
          data.res,
          (data) => {
            this.totalList.sumPerson.nor = data.sumPerson.nor
            this.totalList.sumPerson.abn = data.sumPerson.abn
            this.totalList.sumGate.nor = data.sumGate.nor
            this.totalList.sumGate.abn = data.sumGate.abn
            this.totalList.sumLock.nor = data.sumLock.nor
            this.totalList.sumLock.abn = data.sumLock.abn
          },
          (err) => {
            this.$message.error(err)
          }
        )
      })
    }
  }
}
</script>

<style lang="less">
.home-top {
  .home-top-title,
  p {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%;
  }
  .home-top-title {
    color: #878787;
    font-size: 16px;
    margin-bottom: 10px;
  }
  p {
    color: #878787;
    font-size: 14px;
    //font-weight: bold;
  }
}
</style>
